import {useState} from "react";
import {GlobalState} from "state/GlobalState";
import {ErrorHandling} from "helpers/error-handling";
import ConfirmDeletionDialog from "layouts/main/components/ConfirmDeletionDialog";
import {NewsApi} from "HtvApi/Api";

const NewsDeleteDialogButton = ({id, onConfirm}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);

    const closeDialog = () => {
        setIsLoading(false);
        setData(null);
    };

    const confirmDelete = () => {
        NewsApi
            .newsDelete({id})
            .then(() => {
                GlobalState.setSuccess('Successful operation!', 'News deleted successfully!');
                closeDialog();
                onConfirm && onConfirm();
            })
            .catch(ErrorHandling.GlobalStateError);
    };

    const showConfirmDialog = (e) => {
        e.preventDefault();
        setIsLoading(true);

        NewsApi.newsGet({id}).then(response => {
            setData({
                title: response.data.title,
            });
            setIsLoading(false);
        }).catch(error => {
            ErrorHandling.GlobalStateError(error);
            closeDialog();
        });
    };

    const button =
        <button className="btn btn-sm btn-danger" onClick={e => showConfirmDialog(e)}>
            <i className="far fa-trash-alt" /> Delete
        </button>

    if (data || isLoading) {
        return (
            <>
                {button}
                <ConfirmDeletionDialog
                    isLoading={isLoading}
                    title={data ? `Confirm deletion of news: ${data.title}` : ''}
                    description={''}
                    onCancel={() => closeDialog()}
                    onConfirm={() => confirmDelete()}
                />
            </>
        );
    }

    return button;
};

export default NewsDeleteDialogButton;
